import React from "react";
import { IoFlagOutline } from "react-icons/io5";
import { IconContext } from "react-icons";

export interface IListingFlagProps {
  flags: string[];
  position?: [boolean, boolean];
  icon?: boolean;
  className?: string;
}

export const ListingFlag: React.FC<IListingFlagProps> = ({
  flags,
  className,
  position = [true, true],
  icon = true,
}) => {
  const layoutVariant = `${position[0] ? "top-0" : "top-2"} ${
    position[1] ? "left-0" : "left-2"
  } `;

  return (
    <IconContext.Provider value={{ size: "1.5em", className: "mr-1.5 inline" }}>
      <div className={`whitespace-pre p-2 ${className} ${layoutVariant}`}>
        {flags.map((item, index) => (
          <>
            {icon && (
              <>
                <IoFlagOutline />
                <span className="sr-only">flag</span>
              </>
            )}
            {item + "\n"}
          </>
        ))}
      </div>
    </IconContext.Provider>
  );
};
